export const newsTexts = {
    en: {
        title: {
            line1: 'Information',
            line2: '& News'
        },
        readMore: 'Read more',
        empty: 'No briefings yet',
        loading: 'Loading...'
    },
    zh: {
        title: {
            line1: '资讯',
            line2: '& 新闻'
        },
        readMore: '阅读更多',
        empty: '暂无简讯',
        loading: '加载中...'
    }
}

export const getNewsTexts = (lang) => {
    return newsTexts[lang] || newsTexts.en
}